import React, {
  LegacyRef,
  MutableRefObject,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import screenfull, { Screenfull } from 'screenfull';
import ReactPlayer from 'react-player';
import { IconButton } from 'office-ui-fabric-react';
import { iOS } from 'utils/platform';

import { secureRequest } from 'utils/request';

import { Styled } from './Video.styles';
import { context } from './context';
import { useBoolean } from '../../../../hooks/useBoolean';

export const SingleCam: React.FC = () => {
  const [urlData, setUrlData] = useState<{
    url: string;
    playUrl: string;
  } | null>(null);

  const [loaded, toggleLoaded] = useBoolean();

  const [restartCount, setRestartCount] = useState(0);
  const [tm, setTm] = useState('');

  const playerRef = useRef<HTMLDivElement>(null);
  const reactPlayerRef = useRef<ReactPlayer>(null);

    const videoRef = React.useRef<HTMLVideoElement | null>(null);

  const [hasError, setHasError] = useState(false);
  const [muted, setMuted] = useState(false);

  const { requestId, selectedCam } = useContext(context);

  useEffect(() => {
    let controller: AbortController | null = null;
    const request = async () => {
      if (urlData) {
        controller = new AbortController();
        await fetch(urlData.playUrl, { signal: controller.signal });
      }
    };
    request();
    return () => {
      controller && controller.abort();
    };
  }, [urlData]);

  useEffect(() => {
    const getVideoUrl = async () => {
      const result = await secureRequest<{ url: string; playUrl: string }>(
        `/api/v1/video/online/${requestId}/${selectedCam}`
      );
      setUrlData(result);
    };
    getVideoUrl();
    return () => {
      setUrlData(null);
    };
  }, [requestId, selectedCam]);

  const handleClickFullscreen = () => {
    try{
      if (videoRef && videoRef.current){
       const elem = videoRef.current;
        // @ts-ignore
        if (elem.webkitEnterFullScreen) {
          // @ts-ignore
          elem.webkitEnterFullScreen();
          return;
        }
     }
    } catch(e){}
    try {
      if (playerRef.current) {
        (screenfull as Screenfull).toggle(playerRef.current);
      }
    } catch (error) {
      if (reactPlayerRef.current) {
        const elem = reactPlayerRef.current.getInternalPlayer();
        // @ts-ignore
        if (elem.webkitEnterFullScreen) {
          // @ts-ignore
          elem.webkitEnterFullScreen();
        }
      }
    }
  };

  const handleError = (error: any, data: any) => {
    console.log('error was occurred', error, data);
    if (((error === 'hlsError' && data && data.fatal) || error.type==='error') && restartCount < 40)   {
      setRestartCount((prev) => prev + 1);
      setTimeout(() => setTm(`&tm=${new Date().valueOf()}`), 1000);
    } else {
      setHasError(true);
    }
  };

   const handleCanPlay = () => {
     setRestartCount(0);
     // if (videoRef && videoRef.current){
     //   videoRef.current.play();
     // }

  }


  return (
    <Styled.PlayerWrapper hasError={hasError} ref={playerRef}>
      {urlData &&
        (iOS()?(
        <video
        id="iosplayer"
        ref={videoRef}
          src={`${urlData.url}${tm}`}
          autoPlay={true}
          muted={muted}
          controls={false}
          height="100%"
          width="100%"
          onError={(e) => handleError(e, null)}
          onCanPlay={handleCanPlay}
        />

        ):(
        <ReactPlayer
          ref={reactPlayerRef}
          url={`${urlData.url}${tm}`}
          muted={muted}
          playing={true}
          controls={false}
          onError={handleError}
          onReady={() => setRestartCount(0)}
          height="100%"
          width="100%"
          config={{
            file: {
              hlsOptions: {
                manifestLoadingMaxRetry: 6,
                manifestLoadingTimeOut: 100000,
              },
            },
          }}
        />
      ))}
      <Styled.PlayerControls>
        <span>{selectedCam}</span>
        <IconButton
          onClick={() => setMuted((prev) => !prev)}
          iconProps={{
            iconName: muted ? 'VolumeDisabled' : 'Volume3',
          }}
        />
        <IconButton
          onClick={handleClickFullscreen}
          iconProps={{
            iconName: 'Fullscreen',
          }}
        />
      </Styled.PlayerControls>
    </Styled.PlayerWrapper>
  );
};
